import axios from 'axios';

import { GLOBAL_FETCH_SIGNAL } from './settings';
import { ActionType } from '../action-types';
import { fetchUrl } from './settings';

export const logsData = (systemIDs = null, nodeID = null, searchedText = null, dateStart = null, dateEnd = null) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.LOGS_LOADING });
	axios({
		data: {
			systemIDs: systemIDs,
			nodeID: nodeID,
			searchedText: searchedText,
			dateStart: dateStart,
			dateEnd: dateEnd
		},
		headers: { Authorization: `Bearer ${token}` },
		method: 'POST',
		timeout: 20000,
		url: `${fetchUrl}/logs`,
		retries: 30,
		retryDelay: 500,
		retryOn: function (attempt, error, response) {
			// retry on any network error, or 4xx or 5xx status codes
			if (error !== null || response.status >= 400) {
				return true;
			}
		},
	})
		.then((response) => {
			dispatch({
				type: ActionType.GET_LOGS,
				logs: response.data.Logs,
				logsCount: response.data.LogsCount,
				systemIDs: systemIDs,
				nodeID: nodeID,
				searchedText: searchedText,
				dateStart: dateStart,
				dateEnd: dateEnd
			});
		})
		.catch((err) => {
			dispatch({
				type: ActionType.FETCH_ERROR,
				error: err,
			});
		});
};

export const confirmNotification = (ID: number) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/log`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ logID: ID }),
	})
		.then((resp) => {
			if (resp.ok) {
				return resp.json();
			}
		})
		.then((data) => {
			dispatch({
				type: ActionType.CONFIRMED_LOG, logID: ID
			});
		})
		.catch((err) => {
			console.error(err);
			dispatch({
				type: ActionType.CONFIRMED_LOG_FAILED,
			});
			dispatch({
				type: ActionType.FETCH_ERROR,
				error: err,
			});
		});
};

export const closeConfirmedLogNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CONFIRMED_LOG_CLOSE_NOTIFICATION });
};

export const getSystemsNodesShort = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/systems-nodes-short`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 10,
		retryOn: function (attempt, error, response) {
			// retry on any network error, or 4xx or 5xx status codes
			if (error !== null || response.status >= 400) {
				return true;
			}
			return response.data;
		},
	})
		.then((response) => response.json())
		.then((data) => {
			return dispatch({
				type: ActionType.GET_SYSTEMS_NODES_SHORT,
				systemsNodesShort: data
			});
		})
};

export const getSystemsNodesRoutersShort = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/systems-nodes-routers-short`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 10,
		retryOn: function (attempt, error, response) {
			// retry on any network error, or 4xx or 5xx status codes
			if (error !== null || response.status >= 400) {
				return true;
			}
			return response.data;
		},
	})
		.then((response) => response.json())
		.then((data) => {
			return dispatch({
				type: ActionType.GET_SYSTEMS_NODES_ROUTERS_SHORT,
				systemsNodesRoutersShort: data
			});
		})
};


export const clearLogs = () => (dispatch) => {
	dispatch({ type: ActionType.CLEAR_LOGS });
};

export const sendLog = (ID, update) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/send-log`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ logID: ID, update: update }),
		retries: 10,
		retryOn: function (attempt, error, response) {
			// retry on any network error, or 4xx or 5xx status codes
			if (error !== null || response.status >= 400) {
				return true;
			}
			return response.data;
		},
	});
};
